/* eslint-disable react/forbid-prop-types, react/react-in-jsx-scope */
import {
  faFacebookF,
  faLinkedin,
  faTwitter,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import PropTypes from 'prop-types';
import { useGlobal } from '../contexts/global';
import { buscaPadariaSlug } from '../services/Votacao';
import Patrocinadores from './shared/Patrocinadores';
import saoPauloData from '../data/cidades/sao-paulo.json';
import beloHorizonteData from '../data/cidades/belo-horizonte.json';
import resolverCidadeSlug from '../utils/cidadeAtiva';
import { getFase } from '../utils/fase';

import '../assets/scss/components/PadariaDetalhes.scss';

const PadariaDetalhes = ({ cidade }) => {
  const fase = getFase(cidade);
  const history = useHistory();
  const location = useLocation();
  const { slug } = useParams();
  const { setShowModalVotacao, setIdPadaria, setNomePadaria } = useGlobal();
  const [padaria, setPadaria] = useState({});
  const [loading, setLoading] = useState(true);

  const cidadeSlug = resolverCidadeSlug(cidade, history.location.pathname);
  const cidadeData =
    cidade ||
    (cidadeSlug === 'belo-horizonte' ? beloHorizonteData : saoPauloData);
  const fallbackUrl =
    cidadeSlug === 'belo-horizonte' ? '/belo-horizonte' : '/sao-paulo';
  const siteUrl =
    cidadeSlug === 'belo-horizonte'
      ? 'https://padocariabh.com.br'
      : 'https://padocariasp.com.br';

  const back = (e) => {
    e.stopPropagation();
    const savedCityPage = sessionStorage.getItem('cidadeAtivaPage');
    const targetUrl =
      savedCityPage && !savedCityPage.includes('/padaria/')
        ? savedCityPage
        : fallbackUrl;
    history.push(targetUrl);
  };

  const handleVoteAgora = () => {
    const savedCityPage = sessionStorage.getItem('cidadeAtivaPage');
    const targetUrl =
      savedCityPage && !savedCityPage.includes('/padaria/')
        ? savedCityPage
        : fallbackUrl;
    history.push(targetUrl);
    setIdPadaria(padaria.id);
    setNomePadaria(padaria.nome);
    setShowModalVotacao(true);
  };

  useEffect(() => {
    let unmounted = false;
    setLoading(true);

    const laodPadaria = async () => {
      try {
        const resp = await buscaPadariaSlug(slug);
        if (!unmounted) {
          setPadaria(resp || {});
          setLoading(false);
        }
      } catch (error) {
        if (!unmounted) {
          setLoading(false);
        }
      }
    };
    laodPadaria();

    return () => {
      unmounted = true;
    };
  }, [slug]);

  return (
    <div className="in-details" onClick={back}>
      <div className="in-details-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="in-details-modal__close-btn"
          onClick={back}
          aria-label="Fechar"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#7B3603"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {loading && (
          <div className="in-details-modal__loading">
            <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
            <p>Carregando informações...</p>
          </div>
        )}

        {!loading && !padaria?.nome && (
          <div className="in-details-modal__error">
            <p>Não foi possível carregar as informações desta padaria.</p>
          </div>
        )}

        {!loading && padaria?.nome && (
          <div className="in-details-modal-grid">
            <div className="in-details-modal-grid-sup">
              <img src={padaria.imagem} alt={padaria.nome || 'Padaria'} />
            </div>
            <div className="in-details-modal-grid-sub">
              <div className="in-details-modal-grid-sub-lf">
                <div className="in-details-modal-grid-sub-lf-title">
                  <p className="title">{padaria.nome}</p>
                  <div>
                    <p className="endereco">
                      <strong>Endereço: </strong>
                      {padaria.endereco}
                    </p>
                  </div>
                </div>
                <div className="in-details-modal-grid-sub-lf-dcpt">
                  <p className="descricao">{padaria.descricao}</p>
                </div>
              </div>
              <div className="in-details-modal-grid-sub-rt">
                {fase === '2' && (
                  <div className="in-details-modal-grid-sub-rt-votenow">
                    <button onClick={handleVoteAgora} type="button">
                      Vote agora!
                    </button>
                  </div>
                )}
                <div className="in-details-modal-grid-sub-rt-socials">
                  <p>Compartilhe com seus amigos</p>
                  <div>
                    <FontAwesomeIcon
                      onClick={() => {
                        window.open(
                          `https://www.facebook.com/sharer/sharer.php?u=${siteUrl}${location.pathname}`,
                          '',
                          'width=300,height=500'
                        );
                        return false;
                      }}
                      icon={faFacebookF}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        window.open(
                          `https://twitter.com/share?url=${siteUrl}${location.pathname}`,
                          '',
                          'width=600,height=800'
                        );
                        return false;
                      }}
                      icon={faTwitter}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        window.open(
                          `https://www.linkedin.com/sharing/share-offsite/?url=${siteUrl}${location.pathname}`,
                          '',
                          'width=600,height=800'
                        );
                        return false;
                      }}
                      icon={faLinkedin}
                    />
                    <a
                      href={`https://api.whatsapp.com/send?text=${siteUrl}${location.pathname}`}
                      data-action="share/whatsapp/share"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FontAwesomeIcon icon={faWhatsapp} />
                    </a>
                  </div>
                </div>
              </div>
              <div className="in-footer-patrocinadores">
                {cidadeData.patrocinadores && (
                  <Patrocinadores
                    patrocinadores={cidadeData.patrocinadores}
                    className={`regua-patrocinio--${cidadeSlug}`}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

PadariaDetalhes.propTypes = {
  cidade: PropTypes.shape({
    slug: PropTypes.string,
    nome: PropTypes.string,
    patrocinadores: PropTypes.shape({
      titulo: PropTypes.string,
      grupos: PropTypes.arrayOf(PropTypes.any),
      linhas: PropTypes.arrayOf(PropTypes.any)
    })
  })
};

PadariaDetalhes.defaultProps = {
  cidade: null
};

export default PadariaDetalhes;
